import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Angular's tree-shakable providers
})
export class TearSheetGuardService {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.userService.hasAccess("tear-sheet")).pipe(
      tap((hasAccess) => {
        if (!hasAccess) {
          // Redirect using window.location.href for a hard redirect outside Angular Router
          window.location.href = "/request-invite/tear-sheet";
        }
      }),
      map((hasAccess) => hasAccess)
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
